import { useTranslation } from 'react-i18next'
import { ProfileForm } from '../../../components/profile/ProfileForm'
import { SettingsLayout } from '../../../layouts/SettingsLayout'

/**
 * Settings profile page
 */
export function SettingsProfilePage() {
  const { t } = useTranslation()

  return (
    <SettingsLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold">{t('settings.profileTitle', 'Profile')}</h2>
          <p className="text-sm text-muted-foreground">
            {t('settings.profileDescription', 'Update your personal information.')}
          </p>
        </div>

        <ProfileForm />
      </div>
    </SettingsLayout>
  )
}
